import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { FuaFormData } from 'components/Assessments/FuaAssessment/types/FuaFormData'
import { MedicalBackgroundQuestionnaireItem } from 'components/Assessments/FuaAssessment/sections/MedicalBackground/questionnaire'
import { HistoryFormField } from './formField'

/**
 * History subsection adapter
 * Handles functional limitations, activities permitted, and medical/surgical history (4 fields)
 */
export class HistoryAdapter extends BaseSubsectionAdapter<FuaFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<FuaFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const functionalLimitations = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS
    )

    const activitiesPermitted = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED
    )

    const medicalHistory = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY
    )?.at(0)

    const surgicalHistory = getAnswerValuesFromItems(
      flatAnswersArray,
      MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY
    )?.at(0)

    return {
      [HistoryFormField.HISTORY_FUNCTIONAL_LIMITATIONS]: functionalLimitations,
      [HistoryFormField.HISTORY_ACTIVITIES_PERMITTED]: activitiesPermitted,
      [HistoryFormField.HISTORY_MEDICAL_HISTORY]: medicalHistory,
      [HistoryFormField.HISTORY_SURGICAL_HISTORY]: surgicalHistory
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = [
      {
        linkId:
          MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS,
        value: this.getFormDataField(HistoryFormField.HISTORY_FUNCTIONAL_LIMITATIONS)
      },
      {
        linkId: MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED,
        value: this.getFormDataField(HistoryFormField.HISTORY_ACTIVITIES_PERMITTED)
      },
      {
        linkId: MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY,
        value: this.getFormDataField(HistoryFormField.HISTORY_MEDICAL_HISTORY)
      },
      {
        linkId: MedicalBackgroundQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY,
        value: this.getFormDataField(HistoryFormField.HISTORY_SURGICAL_HISTORY)
      }
    ]

    return mutations
  }
}
